import appIcons from "theme/components/atoms/Icon/icons/app-icons";
import coreIcons from "theme/components/atoms/Icon/icons/core-icons";

/** @type {Record<string, import("react-icons").IconType>} */
const componentIcons = {
  ...coreIcons.componentIcons,
  ...appIcons.componentIcons,
};

/** @type {string[]} */
const svgIcons = [
  ...new Set([...coreIcons.svgIcons, ...(appIcons?.svgIcons || [])]),
];

export default {
  componentIcons,
  svgIcons,
};
